import React from "react";

const Terms = () => {
  return (
    <div
      style={{
        padding: "20px",
        fontFamily: "'Roboto', sans-serif",
        color: "#ffffff",
        background: "linear-gradient(135deg, #0047AB, #00A550)",
        borderRadius: "10px",
        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.3)",
        lineHeight: "1.8",
        maxWidth: "1200px",
        margin: "20px auto",
      }}
    >
      <h1
        style={{
          textAlign: "center",
          marginBottom: "30px",
          color: "#00FFCC",
          fontSize: "2.5rem",
          textShadow: "2px 2px 5px rgba(0, 0, 0, 0.3)",
        }}
      >
        Terms and Conditions
      </h1>

      <section>
        <h2
          style={{
            color: "#00FFCC",
            marginBottom: "15px",
            textTransform: "uppercase",
            borderBottom: "2px solid #00FFCC",
            paddingBottom: "5px",
          }}
        >
          Introduction
        </h2>
        <p
          style={{
            fontSize: "1rem",
            background: "rgba(0, 0, 0, 0.2)",
            padding: "10px 15px",
            borderRadius: "8px",
            marginBottom: "20px",
          }}
        >
          Welcome to the <strong>Ariariamarketplace.com.ng</strong> Multivendor
          website (the "Site"). These terms & conditions ("Terms and
          Conditions") apply to the Site, and all of its divisions,
          subsidiaries, and affiliate-operated Internet sites which reference
          these Terms and Conditions.
        </p>
        <p
          style={{
            fontSize: "1rem",
            background: "rgba(0, 0, 0, 0.2)",
            padding: "10px 15px",
            borderRadius: "8px",
            marginBottom: "20px",
          }}
        >
          This website is owned and operated by AbaNaijaMade Ecart Ltd, a company in
          Nigeria. For the purposes of this website, "seller", "we", "us" and "our" all refer to
          <strong> Ariariamarketplace.com.ng</strong>.
        </p>
        <p
          style={{
            fontSize: "1rem",
            background: "rgba(0, 0, 0, 0.2)",
            padding: "10px 15px",
            borderRadius: "8px",
            marginBottom: "20px",
          }}
        >
          The Site reserves the right to change, modify, add, or remove portions of both the Terms
          and Conditions of Use and the Terms and Conditions of Sale at any time. Changes will be
          effective when posted on the Site with no other notice provided. Please check these Terms
          and Conditions regularly for updates. Your continued use of the Site following the posting
          of changes to these Terms and Conditions constitutes your acceptance of those changes.
        </p>
      </section>

      <section>
        <h2
          style={{
            color: "#00FFCC",
            marginBottom: "15px",
            textTransform: "uppercase",
            borderBottom: "2px solid #00FFCC",
            paddingBottom: "5px",
          }}
        >
          Terms and Conditions of Use
        </h2>

        <h3
          style={{
            color: "#00FFCC",
            marginBottom: "10px",
            textTransform: "uppercase",
          }}
        >
          Payment for Products
        </h3>
        <p
          style={{
            fontSize: "1rem",
            background: "rgba(0, 0, 0, 0.2)",
            padding: "10px 15px",
            borderRadius: "8px",
            marginBottom: "20px",
          }}
        >
          All payments to be made for products on this Site must be via our online payment channels.
          Wholesalers and Customers must Pay/Receive through our platform for security and prompt
          products delivery and payment system.
        </p>
        <p
          style={{
            fontSize: "1rem",
            background: "rgba(0, 0, 0, 0.2)",
            padding: "10px 15px",
            borderRadius: "8px",
            marginBottom: "20px",
          }}
        >
          Where a customer prefers to make bank transfer payments, such payments MUST be made
          through AbaNaijaMade Ecart Ltd Company's Bank Account to be provided.
        </p>
      </section>

      <section>
        <h3
          style={{
            color: "#00FFCC",
            marginBottom: "10px",
            textTransform: "uppercase",
          }}
        >
          Use of the Site
        </h3>
        <p
          style={{
            fontSize: "1rem",
            background: "rgba(0, 0, 0, 0.2)",
            padding: "10px 15px",
            borderRadius: "8px",
            marginBottom: "20px",
          }}
        >
          You confirm that you are at least 18 years of age or are accessing the Site under the
          supervision of a parent or legal guardian. Both parties agree that this website may only
          be used in accordance with these Terms and Conditions of Use.
        </p>
      </section>

      <footer
        style={{
          marginTop: "40px",
          textAlign: "center",
          fontSize: "0.9em",
          color: "#00FFCC",
        }}
      >
        <p>
          © 2024 AbaNaijaMade Ecart Ltd. All rights reserved. For more information, please contact
          us.
        </p>
      </footer>
    </div>
  );
};

export default Terms;
